import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const STATIC_BASE = process.env.REACT_APP_STATIC_BASE || `${BACKEND_URL}/api/static`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("luva_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // do not auto-redirect from public pages
      const path = window.location.pathname;
      if (path.startsWith("/admin/dashboard")) {
        localStorage.removeItem("luva_token");
        window.location.href = "/admin";
      }
    }
    return Promise.reject(err);
  }
);

export const photoUrl = (p) => {
  if (!p) return "";
  const folder = p.folder || "fotos";
  return `${STATIC_BASE}/${folder}/${p.filename}`;
};
export const clientUrl = (c) => `${STATIC_BASE}/clientes/${c.filename}`;
export const logoUrl    = (fn) => `${STATIC_BASE}/logo/${fn}`;
export const faviconUrl = (fn) => `${STATIC_BASE}/favicon/${fn}`;
export const isVideo = (p) => /\.(mp4|webm|mov)$/i.test(p?.filename || "");
